import api from "./api";
import { getOrganizationSettings } from "./utils/storage";

// Initialize Transfer
export async function initiateTransfer({
  source_wallet_number,
  destination_account_number,
  bank_id,
  amount,
  description,
}) {
  try {
    const token = localStorage.getItem("token");
    const newOrg = getOrganizationSettings();

    const appid = newOrg.id;


    const response = await api.post(
      "customers/wallet-to-bank-transaction/initiate",
      {
        source_wallet_number,
        destination_account_number,
        bank_id,
        amount,
        description,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AppID: appid,
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to initiate transfer:", error);
    throw error;
  }
}

// Process Transfer
export async function processTransfer({
  source_wallet_number,
  destination_account_number,
  bank_id,
  amount,
  description,
  transaction_pin,
}) {
  try {
    const token = localStorage.getItem("token");
    const newOrg = getOrganizationSettings();
    const appid = newOrg.id;

    const response = await api.post(
      "customers/wallet-to-bank-transaction/process",
      {
        source_wallet_number,
        destination_account_number,
        bank_id,
        amount,
        description,
        transaction_pin,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AppID: appid,
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to process transfer:", error);
    throw error;
  }
}
